import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import APPSETTINGS from '@appsettings';
const variantStyles = {
    beta: 'app-banner--beta',
    dev: 'app-banner--dev',
    warning: 'app-banner--warning',
    info: 'app-banner--info',
};
function AppBanner({ banners }) {
    const [dismissedIds, setDismissedIds] = React.useState(() => {
        const stored = localStorage.getItem('app-banners-dismissed');
        return stored ? new Set(JSON.parse(stored)) : new Set();
    });
    const openFeedbackWidget = () => {
        const userback = window.Userback;
        if (userback === null || userback === void 0 ? void 0 : userback.open) {
            userback.open('general', 'form');
        }
    };
    const handleDismiss = (id) => {
        const newDismissed = new Set(dismissedIds).add(id);
        setDismissedIds(newDismissed);
        localStorage.setItem('app-banners-dismissed', JSON.stringify(Array.from(newDismissed)));
    };
    const visibleBanners = banners.filter(b => !dismissedIds.has(b.id));
    if (visibleBanners.length === 0)
        return null;
    return (_jsx(_Fragment, { children: visibleBanners.map(banner => (_jsx("div", { className: `app-banner ${banner.color ? '' : variantStyles[banner.variant]}`, style: banner.color ? { backgroundColor: banner.color } : undefined, children: _jsxs("div", { className: "app-banner-content", children: [_jsxs("span", { children: [banner.message, banner.showFeedbackLink && APPSETTINGS.USERBACK_KEY && (_jsxs(_Fragment, { children: [' ', _jsx("a", { href: "#", onClick: (e) => { e.preventDefault(); openFeedbackWidget(); }, children: "Share feedback" })] }))] }), banner.dismissible && (_jsx("button", { type: "button", className: "app-banner-close", onClick: () => handleDismiss(banner.id), "aria-label": "Dismiss banner", children: _jsx("i", { className: "bi bi-x-lg" }) }))] }) }, banner.id))) }));
}
export default AppBanner;
